import { Component } from "@angular/core";
import { Store, createSelector } from "@ngrx/store";
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { FreyaCommonModule } from "src/app/freya-common/freya-common.module";

import { BaseJobFragment } from '../../../../generated/graphql.generated';
import { createConfigSelector } from '../../../state/branding.store';

import { jobToolFeature, selectJob } from "../../job-tool.reducer";

import { CloseJobComponentActions } from "./close-job-component.actions";

export interface CloseJobDialogState {
  job?: BaseJobFragment;
  jobId?: string;
  selectedCloseReason?: string;
  saveFormChanges?: boolean;
}

@Component({
    selector: 'app-job-close-job-component',
    standalone: true,
    imports: [
      FreyaCommonModule,
    ],
    templateUrl: './close-job-component.component.html',
    styleUrls: ['./close-job-component.component.scss']
  })
  export class JobCloseJobComponent {

    constructor(
      public store: Store,
      public ref: DynamicDialogRef,
    ) {}

    public actions = CloseJobComponentActions;

    public viewModel$ = this.store.select(createSelector({
      closedReason: jobToolFeature.selectClosedReason,
      closureReasons: createSelector(
        createConfigSelector('JOBS_CLOSEDREASONS'),
        selectJob,
        (reasons, job): MenuItem[] => {

          const stage = job?.stage || 'lead';

          return reasons
            .filter((r) => r.stages?.length === 0 || r.stages.includes(stage))
            .map((r) => ({
              label: r.title,
              title: r.title,
              id: r.id,
            }));
        }
      ),
    }));
  }
